import { render, staticRenderFns } from "./TestCheckAnswersTab.vue?vue&type=template&id=f44f6e2a&scoped=true&"
import script from "./TestCheckAnswersTab.vue?vue&type=script&lang=js&"
export * from "./TestCheckAnswersTab.vue?vue&type=script&lang=js&"
import style0 from "./TestCheckAnswersTab.vue?vue&type=style&index=0&id=f44f6e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44f6e2a",
  null
  
)

export default component.exports